<template>
    <div class="row">
        <div class="col-md-4">
            <task-trackers
                    ref="taskTrackers"
                    :task="task"
                           @updated="taskTrackersUpdated">
            </task-trackers>
        </div>
        <div class="col-md-8">
            <task-timers :task="task" :taskTrackersSync.sync="taskTrackers" @removeTracker="removeTrackerHandler">
            </task-timers>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            task: Object,
        },
        data() {
            return {
                taskTrackers: [],
            }
        },
        name: "task-tracking-timers",
        methods: {
            taskTrackersUpdated(newValue) {
                this.taskTrackers = newValue;
            },
            removeTrackerHandler(trackerForRemove){
               this.$refs.taskTrackers.removeTaskTracker(trackerForRemove.taskTracker);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskTrackingTimers.vue